import { render, staticRenderFns } from "./FichaChamados.vue?vue&type=template&id=598ad6fa&"
import script from "./FichaChamados.vue?vue&type=script&lang=js&"
export * from "./FichaChamados.vue?vue&type=script&lang=js&"
import style0 from "./FichaChamados.vue?vue&type=style&index=0&id=598ad6fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports